<template>
  <div
    :id="action.id"
    :name="action.id"
    class="w-full vx-row flex-col card"
    :class="[
      isSelected ? 'selected-card' : '',
      isTrigger ? 'trigger-card' : '',
      action.start && action.start.value === 'with_previous' ? 'with-previous' : 'after-previous',
      getActionClass,
      !validationResult.isValid ? 'invalid-card' : ''
    ]"
    :style="delayStyles"
    @click.stop="$emit('select')"
  >
    <!-- Validation error badge -->
    <vx-tooltip v-if="!validationResult.isValid" :text="validationTooltip" position="top">
      <div class="validation-badge">
        <vs-icon icon="error_outline" size="small" color="danger" />
      </div>
    </vx-tooltip>
    
    <!-- Delay line connector -->
    <div v-if="hasDelay" class="delay-connector" :style="delayConnectorStyles">
      <div class="delay-time">{{ action.delay }}s</div>
    </div>
    
    <div class="vx-row">
      <!-- Action Icon -->
      <div class="vx-col w-2/12 mt-2 mb-2 items-center">
        <div class="action-type-icon" :class="{'trigger-icon': isTrigger}">
          <vs-icon
            color="white"
            disabled
            type="flat"
            class="border-2"
            size="20px"
            :icon="actionIcons[action.type] || 'help'"
          />
          <div v-if="isTrigger" class="trigger-indicator"></div>
        </div>
      </div>
      <!-- Action Description with Trigger Label -->
      <div class="vx-col w-8/12 flex mt-2 mb-2 items-center">
        <div>
          <div class="flex items-center">
            <span v-if="isTrigger" class="trigger-label">TRIGGER</span>
            <span v-if="hasDelay" class="delay-label">DELAY {{ action.delay }}s</span>
            <span v-if="isRepeating" class="repeat-label">
              REPEAT {{ action.repeat.count === -1 ? '∞' : action.repeat.count }}
            </span>
          </div>
          <p>{{ actionDescription }}</p>
        </div>
      </div>
      
      <!-- Action Controls -->
      <div class="vx-col w-2/12 flex items-center">
        <vs-row vs-type="flex" vs-justify="flex-end" class="w-full">
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3" class="mr-3">
            <vx-tooltip text="Duplicate this element" position="top">
              <vs-icon
                @click.stop="$emit('duplicate')"
                icon="content_copy"
                size="xsmall"
                color="primary"
              />
            </vx-tooltip>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
            <vx-tooltip text="Delete this element" position="top">
              <vs-icon
                @click.stop="$emit('remove')"
                icon="delete"
                size="xsmall"
                color="primary"
              />
            </vx-tooltip>
          </vs-col>
        </vs-row>
      </div>
    </div>
    <div v-if="action.type == 'trigger_match_to_place'">
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-checkbox class="mb-3 mt-3" v-model="action.show_preview">Show Preview</vs-checkbox>
              </div>
              <div v-show="action.show_preview" class="vx-col w-1/2">
                <span>Preview Text:</span>
                <vs-input class="w-full mb-3" name="name" v-model="action.preview_instructions_text" />
              </div>
              <div v-show="action.show_preview" class="vx-col w-1/2">
                <span>Preview Button Text:</span>
                <vs-input class="w-full mb-3" name="name" v-model="action.preview_button_text" />
              </div>
              <div class="vx-col w-full">
                <span>Instructions Text:</span>
                <vs-input class="w-full mb-3" name="name" v-model="action.instructions_text" />
              </div>
              <div class="vx-col w-full">
                <span>Instructions Button Text:</span>
                <vs-input class="w-full mb-3" name="name" v-model="action.instructions_button_text" />
              </div>
            </div>
          </div>

          <div v-if="action.type == 'trigger_amqp_message_received'">
            <div class="vx-row">
              <div class="vx-col w-1/3">
                <span>Host:</span>
                <vs-input class="w-full mb-2" name="name" v-model="action.host" />
              </div>
              <div class="vx-col w-1/3">
                <span>Port:</span>
                <vs-input class="w-full mb-2" name="name" v-model="action.port" />
              </div>
              <div class="vx-col w-1/3">
                <span>Username:</span>
                <vs-input class="w-full mb-2" name="name" v-model="action.username" />
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col w-1/3">
                <span>Password:</span>
                <vs-input class="w-full mb-2" v-model="action.password" />
              </div>
              <div class="vx-col w-1/3">
                <span>VirtualHost:</span>
                <vs-input class="w-full mb-2" name="name" v-model="action.virtual_host" />
              </div>
              <div class="vx-col w-1/3">
                <span>Exchange:</span>
                <vs-input class="w-full mb-2" name="name" v-model="action.exchange" />
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-1/3">
                <span>Routing Key:</span>
                <vs-input class="w-full mb-2" name="name" v-model="action.routing_key" />
              </div>
              <div class="vx-col w-1/3">
                <span>SelectedToken:</span>
                <vs-input class="w-full mb-2" name="name" v-model="action.selected_token" />
              </div>
              <div class="vx-col w-1/3">
                <span>Message:</span>
                <vs-input class="w-full mb-2" name="name" v-model="action.message" />
              </div>
            </div>
          </div>
          <div v-if="action.type == 'trigger_event_received'">
            <div class="vx-row">
              <div class="vx-col w-1/3">
                <span>Type:</span>
                <vs-input class="w-full mb-2" name="name" v-model="action.event_type" />
              </div>
              <div class="vx-col w-2/3">
                <span>Message:</span>
                <vs-input class="w-full mb-2" name="name" v-model="action.event_message" />
              </div>
            </div>
          </div>
          <div v-if="action.type == 'trigger_mqtt_message_received'">
            <div class="vx-row">
              <div class="vx-col w-1/3">
                <span>Host:</span>
                <vs-input class="w-full mb-2" name="name" v-model="action.host" />
              </div>
              <div class="vx-col w-1/3">
                <span>Username:</span>
                <vs-input class="w-full mb-2" name="name" v-model="action.username" />
              </div>
              <div class="vx-col w-1/3">
                <span>Password:</span>
                <vs-input class="w-full mb-2" v-model="action.password" />
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col w-full">
                <span>Read Topic:</span>
                <vs-input class="w-full mb-2" name="name" v-model="action.read_topic" />
              </div>
            </div>
          </div>
          <div
            v-show="
              action.type == 'trigger_screen_tap' ||
                action.type == 'trigger_image_anchor_found' ||
                action.type == 'trigger_image_anchor_lost'
            "
          >
            <div v-show="action.type != 'trigger_screen_tap'">
              <span>Reference Image:</span>
              <v-select
                :clearable="false"
                v-model="action.anchor"
                :reduce="option => option.id"
                label="name"
                class="mb-3 w-full"
                :options="referenceImageOptions"
              />
            </div>
            <div
              v-if="
                action.type == 'trigger_image_anchor_found' ||
                action.type == 'trigger_screen_tap' ||
                action.type == 'trigger_user_aligned_anchor'
              "
            >
              <vs-checkbox class="mb-3" v-model="action.show_instructions"
                >Show instructions</vs-checkbox
              >
              <div v-if="action.show_instructions">
                <div v-if="action.type == 'trigger_screen_tap'">
                <span>Instructions image (optional):</span>
                <file-pond
                  :imagePreviewHeight="200"
                  name="test"
                  ref="instructionImageFilePond"
                  :label-idle="this.$t('HoverpackImageDrag')"
                  :allow-multiple="false"
                  :instant-upload="false"
                  accepted-file-types="image/jpeg, image/png"
                  v-on:removefile="onInstructionImageRemoved"
                  v-on:addfile="onInstructionImageAdded"
                  v-on:init="onFilePondInit"
                />
              </div>
              <span>Instructions text:</span>
                <vs-input class="w-full mb-3" name="name" v-model="action.instructions_text" />
                <!-- <span>Instructions text background</span>
          <vs-input
            class="w-full mb-3"
            placeholder="#000000"
            name="name"
            v-model="action.instructions_text_background"
          /> -->
              </div>
            </div>
          </div>
          <div
            v-show="
              action.type == 'trigger_user_aligned_anchor'
            "
          >
              <span>Stencil</span>
              <v-select
                :clearable="false"
                v-model="action.anchor"
                :reduce="option => option.id"
                label="name"
                class="mb-3 w-full"
                :options="stencilOptions"
              />
            <div
              v-if="
                action.type == 'trigger_image_anchor_found' ||
                action.type == 'trigger_screen_tap' ||
                  action.type == 'trigger_user_aligned_anchor'
              "
            >
              <vs-checkbox class="mb-3" v-model="action.show_instructions"
                >Show instructions</vs-checkbox
              >
              <div v-if="action.show_instructions">
                <span>Instructions text:</span>
                <vs-input class="w-full mb-3" name="name" v-model="action.instructions_text" />
                <!-- <span>Instructions text background</span>
          <vs-input
            class="w-full mb-3"
            placeholder="#000000"
            name="name"
            v-model="action.instructions_text_background"
          /> -->
              </div>
            </div>
          </div>

          <div
            v-if="
              action.type == 'trigger_tap' ||
                action.type == 'trigger_enter_portal' ||
                action.type == 'trigger_exit_portal' ||
                action.type == 'trigger_proximity_enter' ||
                action.type == 'trigger_proximity_exit' ||
                action.type == 'trigger_focus_in' ||
                action.type == 'trigger_focus_out'
            "
          >
            <span>Object(s):</span>
            <!-- Note: the :key in the v-select is only there to force refresh of internal state when changing trigger type -->
            <v-select
              :clearable="false"
              v-model="action.targets"
              multiple
              label="text"
              class="mb-2 w-full"
              :options="nodePidHobjectNameOptions"
              :key="action.id + '-' + action.type"
            />
          </div>
          <div
            v-if="
              action.type == 'trigger_match_to_place' ||
                action.type == 'trigger_tap_to_place'
            "
          >
            <span v-show="action.type == 'trigger_match_to_place'"
              >Object to use as stencil</span
            >
            <span v-show="action.type == 'trigger_tap_to_place'"
              >Object to use as reference (optional)
            </span>
            <!-- Note: the :key in the v-select is only there to force refresh of internal state when changing trigger type -->
            <v-select
              v-model="action.target"
              label="text"
              class="mb-2 w-full"
              :options="nodePidHobjectNameOptions"
              :key="action.id + '-' + action.type"
            />
          </div>
          <div
            v-if="
              action.type == 'trigger_proximity_enter' ||
                action.type == 'trigger_proximity_exit'
            "
          >
            <span>Distance (meters):</span>
            <vs-input
              min="0"
              max="10000"
              :step="1"
              class="w-full mb-5"
              v-model="action.distance"
              icon-inc="expand_less"
              icon-dec="expand_more"
            />
          </div>
          <div
            v-if="
              action.type == 'trigger_collision_enter' ||
                action.type == 'trigger_collision_exit'
            "
          >
            <span>Between object:</span>
            <!-- Note: the :key in the v-select is only there to force refresh of internal state when changing trigger type -->
            <v-select
              :clearable="false"
              v-model="action.monitored_object"
              label="text" 
              class="mb-2 w-full"
              :options="nodePidHobjectNameOptions"
              :key="action.id + '-' + action.type"
            />
            <span>And object(s):</span>
            <v-select
              :clearable="false"
              v-model="action.targets"
              multiple
              label="text"
              class="mb-2 w-full"
              :options="nodePidHobjectNameOptions"
              :key="action.id + '-' + action.type"
            />
          </div>
          <div
            v-if="
              action.type == 'trigger_tap' ||
                action.type == 'trigger_image_anchor_found' ||
                action.type == 'trigger_screen_tap' ||
                action.type == 'trigger_enter_portal' ||
                action.type == 'trigger_exit_portal' ||
                action.type == 'trigger_proximity_enter' ||
                action.type == 'trigger_proximity_exit'||
                action.type == 'trigger_collision_enter' ||
                action.type == 'trigger_collision_exit'||
                action.type == 'trigger_focus_in'||
                action.type == 'trigger_focus_out'
            "
          ></div>
        </div>
</template>

<script>
import { SEQUENCE_ELEMENT_ICONS } from '../constants/sequence-element-icons';
import vSelect from 'vue-select'
import { getActionDescription, getActionHobjectImages, getActionClass, validateSequenceElement } from '../utils/sequence-element-utils';
// Import Vue FilePond
import vueFilePond from 'vue-filepond'

// Import FilePond styles
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'

import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImageTransform from 'filepond-plugin-image-transform'
import FilePondPluginImageResize from 'filepond-plugin-image-resize'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginFileEncode from 'filepond-plugin-file-encode';

import imageCompression from 'browser-image-compression'

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
  FilePondPluginImageExifOrientation,
  FilePondPluginImageResize,
  FilePondPluginImageTransform,
  FilePondPluginFileEncode
)


export default {
  name: 'SequenceElementCard',
  
  props: {
    action: {
      type: Object,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    nodePidHobjectNameOptions: {
      type: Array,
      default: () => []
    },
    referenceImageOptions: {
      type: Array,
      default: () => []
    },
    stencilOptions: {
      type: Array,
      default: () => []
    }
  },
  components: {
    'v-select': vSelect,
  },
  mounted() {
    console.log('SequenceElementCard mounted');
    console.log(this.action);
  },
  
  emits: ['select', 'remove', 'duplicate'],
  
  computed: {
    actionIcons() {
      return SEQUENCE_ELEMENT_ICONS;
    },
    
    getActionClass() {
      return getActionClass(this.action);
    },
    
    actionDescription() {
      console.log(getActionHobjectImages(this.action));
      return getActionDescription(this.action);
    },
    
    isTrigger() {
      return this.action.type && this.action.type.startsWith('trigger_');
    },
    
    hasDelay() {
      return this.action.delay && parseFloat(this.action.delay) > 0;
    },
    isRepeating() {
      console.log(this.action.repeat);
      return this.action.repeat && 
              (this.action.repeat > 1 || this.action.repeat === -1);
    },    
    delayStyles() {

      if (!this.hasDelay) {
        // If with_previous but no delay, just add standard indent
        if (this.action.start && this.action.start.value === 'with_previous') {
          // return { marginTop: '0px' };
        }
        return {};
      }
      
      const delay = parseFloat(this.action.delay);
      const scaleFactor = 15;
      const offset = delay <= 3 ? delay * scaleFactor : 
                    (3 * scaleFactor) + (Math.log(delay - 2) * scaleFactor);
      
      // All elements with delay get the same margin calculation
      if (this.action.start && this.action.start.value === 'with_previous') {
        return { marginLeft: `${20 + offset}px` }; // L-connector + delay offset
      }
      
      return { marginLeft: `${offset}px` };
    },
    
    delayConnectorStyles() {
      if (!this.hasDelay) return {};
      
      const delay = parseFloat(this.action.delay);
      const scaleFactor = 17;
      const width = delay <= 3 ? delay * scaleFactor : 
                   (3 * scaleFactor) + (Math.log(delay - 2) * scaleFactor);
      
      // For with_previous, position connector between timeline and card
      if (this.action.start && this.action.start.value === 'with_previous') {
        return {
          width: `${width}px`, 
          right: '100%',  // Start from card edge
          left: 'auto'
        };
      }
      
      // For regular elements
      return {
        width: `${width}px`,
        right: '100%'
      };
    },
    
    validationResult() {
      return validateSequenceElement(this.action);
    },
    
    validationTooltip() {
      if (!this.validationResult.isValid) {
        return this.validationResult.errors.join('\n');
      }
      return '';
    }
  },
  methods: {
    // Handle image removal from FilePond
    // This will set the base64 to null in the local sequence
    // so that it doesn't get uploaded again
    onInstructionImageRemoved: function (error, file) {
      if (!this.action) return;
      this.action.instructions_image_base64 = null;
    },

    async onInstructionImageAdded(error, file) {
      const resizeOptions = {
        maxSizeMB: 0.5,
        maxWidthOrHeight: 512,
        useWebWorker: true,
      }

      // Compress the image file and extract base64 string
      const compressedFile = await imageCompression(file.file, resizeOptions);
      const base64 = await imageCompression.getDataUrlFromFile(compressedFile)

      //Remove the mime type from the base64 string
      const finalBase64 = base64.split(',')[1];
      this.action.instructions_image_base64 = finalBase64; 
    },

    onFilePondInit: function() {
      // Initialize filePong with the instruction image in base64
      if (this.action.instructions_image_base64) {
        if (this.$refs.instructionImageFilePond) {
          this.$refs.instructionImageFilePond.addFile( "data:image/png;base64," + this.action.instructions_image_base64)
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* Card styling with dots ON the line */
.card {
  position: relative;
  margin: 0 0 0 0;
  padding: 4px 15px;
  background: white;
  border-radius: 8px;
  border: 1px solid #eaeaea;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
}

/* Action icon styling */
.action-type-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: rgba(var(--vs-primary), 1);
  box-shadow: 0 2px 4px rgba(var(--vs-primary), 0.3);
}

/* Trigger icon */
.trigger-icon {
  background-color: #f8ba0b;
  box-shadow: 0 2px 4px rgba(248, 186, 11, 0.3);
}

/* Awaiting indicator for triggers */
.trigger-indicator {
  position: absolute;
  top: -4px;
  right: -4px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ffcc00;
  border: 2px solid white;
  animation: pulse 2s infinite;
}

/* Awaiting label for triggers */
.trigger-label {
  font-size: 0.65rem;
  font-weight: bold;
  letter-spacing: 0.5px;
  color: #f8ba0b;
  background-color: rgba(248, 186, 11, 0.1);
  padding: 2px 6px;
  border-radius: 10px;
  margin-right: 8px;
  display: inline-block;
  text-transform: uppercase;
}

/* Delay connector line (dotted) */
.delay-connector {
  position: absolute;
  height: 0; /* Height becomes 0 when using border for the line */
  border-top: 2px dotted #ff9800; /* Create dotted line */
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}

/* Time display on the delay line */
.delay-time {
  position: absolute;
  top: -16px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ff9800;
  color: white;
  padding: 1px 5px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: bold;
  white-space: nowrap;
  z-index: 3; /* Ensure label is on top */
}

/* Delay label */
.delay-label {
  font-size: 0.65rem;
  font-weight: bold;
  letter-spacing: 0.5px;
  color: #ff9800;
  background-color: rgba(255, 152, 0, 0.1);
  padding: 2px 6px;
  border-radius: 10px;
  margin-right: 8px;
  display: inline-block;
}

/* Repeat label styling */
.repeat-label {
  font-size: 0.65rem;
  font-weight: bold;
  letter-spacing: 0.5px;
  color: #8e44ad; /* Purple color to distinguish from other badges */
  background-color: rgba(142, 68, 173, 0.1);
  padding: 2px 6px;
  border-radius: 10px;
  margin-right: 8px;
  display: inline-block;
  text-transform: uppercase;
}

/* Add this for when multiple badges appear together */
.trigger-label + .delay-label,
.trigger-label + .repeat-label,
.delay-label + .repeat-label {
  margin-left: 4px;
}

/* Simultaneous elements (with_previous) */
.with-previous {
  position: relative;
  margin-top: 5px;
}

/* Override delay connector positioning for with_previous elements */
.with-previous .delay-connector {
  right: 100%;
  left: auto;
  width: auto; /* Let the computed width handle this */
  transform: translateY(-50%);
  z-index: 1;
}

/* Selected state styling */
.selected-card.with-previous, .selected-card.after-previous {
  border-color: rgba(var(--vs-primary), 0.7);
  background-color: rgba(var(--vs-primary), 0.1);
  
  &::after,
  & .vx-row::before {
    background-color: rgba(var(--vs-primary), 1);
  }
}

/* Sequential elements (after_previous) */
// .after-previous {
//   margin-top: 15px;
// }

/* Pulse animation for waiting indicators */
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(248, 186, 11, 0.7);
  }
  
  70% {
    box-shadow: 0 0 0 6px rgba(248, 186, 11, 0);
  }
  
  100% {
    box-shadow: 0 0 0 0 rgba(248, 186, 11, 0);
  }
}

/* Validation styling */
.invalid-card {
  border: 1px solid rgba(var(--vs-danger), 0.5) !important;
  background-color: rgba(var(--vs-danger), 0.05) !important;
}

.validation-badge {
  position: absolute;
  top: -8px;
  right: 10px;
  width: 20px;
  height: 20px;
  background-color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  z-index: 10;
  cursor: pointer;
}

/* Action icon wrapper needs position relative */
.vx-col {
  position: relative;
}

/* Subtle hover effects for action control icons */
.vx-col .vs-icon {
  cursor: pointer;
  transition: opacity 0.2s ease, transform 0.1s ease;
  
  &:hover {
    opacity: 0.8;
    transform: translateY(-1px);
  }
  
  &:active {
    transform: translateY(0);
  }
}
</style>